export function scrollToFirstError(errors: Record<string, any>) {
  const formElements = document.querySelectorAll('input, select, textarea, .ckeditor');

  for (let i = 0; i < formElements.length; i++) {
    const el = formElements[i] as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

    const id = el.id?.replace(/^ckeditor-/, '')
    if (id && errors.hasOwnProperty(id)) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      break;
    }
  }
}
